import { render, staticRenderFns } from "./statisticsPanle.vue?vue&type=template&id=a704f4dc&"
import script from "./statisticsPanle.vue?vue&type=script&lang=js&"
export * from "./statisticsPanle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/statistics/statisticsPanle.vue"
export default component.exports